import { useMutation, useQueryClient } from '@tanstack/react-query';

import { invalidateClinicalBundle } from '../lib/invalidateSessionCaches';
import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useSubmitSessionNote(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => sessionsService.submitNote(sessionId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: sessionsKeys.operation('note', sessionId) });
      void qc.invalidateQueries({ queryKey: sessionsKeys.operation('note-meta', sessionId) });
      // Drawer renders from the clinical bundle — refresh so the submitted
      // state (read-only, no Edit) shows live.
      invalidateClinicalBundle(qc, sessionId);
    },
  });
}
